module.exports = __webpack_public_path__ + "img/11.90b4ae59.gif";